import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
export function WhyItFailed() {
  const reasons = ['Las recetas gratuitas de YouTube omiten el "Protocolo de Tostado" necesario para que el kataifi soporte la humedad del relleno.', 'Usar cualquier crema de pistacho del súper suele dar un sabor demasiado dulce y empalagoso que arruina la sofisticación del chocolate amargo.', 'Sin una barrera térmica de chocolate, el crujiente desaparece tan pronto como el pastel entra al refrigerador.'];
  return <section className="py-20 px-6 bg-dark-lighter" data-id="element-188">
      <div className="max-w-4xl mx-auto" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="mb-12 text-center" data-id="element-190">
          <h2 className="font-serif text-3xl md:text-4xl text-gold mb-4" data-id="element-191">
            Por qué lo que intentaste no funcionó
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-192">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} viewport={{
          once: true
        }} className="flex items-start gap-4 bg-dark p-6 rounded-lg border border-white/5" data-id="element-193">
              <div className="mt-1 flex-shrink-0" data-id="element-194">
                <AlertTriangle className="w-6 h-6 text-gold/70" data-id="element-195" />
              </div>
              <p className="font-sans text-cream-muted leading-relaxed" data-id="element-196">
                {reason}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}